import type {ComponentProps} from "react";
import type {ImageProps as HeroImageProps} from "@heroui/image";

import {Image as HeroImage} from "@heroui/image";
import NextImage from "next/image";

export type ImageProps = HeroImageProps & ComponentProps<typeof NextImage>;

export const Image = ({...props}: ImageProps) => {
  return <HeroImage as={NextImage} {...props} />;
};
